import {
  Building2,
  CalendarDays,
  CircleDollarSign,
  FileText,
  FileUp,
  Handshake,
  Home,
  KeyRound,
  LineChart,
  ShieldCheck,
  StickyNote,
  UserCog,
  Users,
  Wrench,
} from "lucide-react";

/** The six places the owner works every day (mirrors the old spreadsheet tabs). */
export const primaryNavigation = [
  { label: "Home", path: "/dashboard", icon: Home },
  { label: "Ledger", path: "/ledger", icon: CircleDollarSign },
  { label: "Houses", path: "/houses", icon: Building2 },
  { label: "Maintenance", path: "/maintenance", icon: Wrench },
  { label: "Contacts", path: "/contacts", icon: Users },
  { label: "Accounts", path: "/vault", icon: KeyRound },
];

/** Everything else, one click away under "More". */
export const moreNavigation = [
  { label: "Calendar", path: "/calendar", icon: CalendarDays },
  { label: "Insurance & licenses", path: "/insurance", icon: ShieldCheck },
  { label: "Documents", path: "/documents", icon: FileText },
  { label: "Notes", path: "/notes", icon: StickyNote },
  { label: "Reports & repeats", path: "/finance", icon: LineChart },
  { label: "Manage tenants", path: "/tenants", icon: Users },
  { label: "Manage contractors", path: "/contractors", icon: Handshake },
  { label: "Import spreadsheet", path: "/import", icon: FileUp },
  { label: "Settings", path: "/profile", icon: UserCog },
];

/** Flat list for the ⌘K "Go to…" palette. */
export const navigation = [
  ...primaryNavigation.map((item) => ({ ...item, group: "Main" })),
  ...moreNavigation.map((item) => ({ ...item, group: "More" })),
];
